import { Navigate, useRoutes } from 'react-router-dom';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
 import { authRoutes } from './auth';
import { appRoutes } from './app';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // App routes
    ...appRoutes,


    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
